import React from 'react'
import {connect} from 'react-redux'
import styles from './auth.scss'

import {checkSMStoken, resendSMStoken} from 'state/actions'

import i18n from 'lib/i18n'
const _ = i18n('sms')

@connect(state => ({
	errors: state.auth.errors,
	isPhone: state.responsive.isPhone,
}))
export default class Sms extends React.Component {
	static propTypes = {
		dispatch: React.PropTypes.func.isRequired,
		errors: React.PropTypes.object,
		options: React.PropTypes.object,
		isPhone: React.PropTypes.bool,
	}
	verifyClicked(ev) {
		ev.preventDefault()

		const {dispatch} = this.props
		const token = this.refs.token.value
		dispatch(checkSMStoken(token,false,false))
	}
	resendToken() {
		const {dispatch} = this.props
		dispatch(resendSMStoken())
	}
	render() {
		const {errors, options} = this.props

		return (
			<div className={styles.authFormsContainer}>
				<div className={styles.loginForm}>
					<div className={styles.formImage}>
						<img src={require("resources/images/BE_Logo_OVB_Willemot_Blue_cmyk.svg")}/>
					</div>
					<div className={styles.info}>
						{options.smsSent
						?
						options.smsResent
							?
							(_('newSmsMSG') + " " + options.number)
							:
							(_('firstSmsMSG') + " " + options.number)
						:
						(_('secondSmsMSG') + options.number + ")")
					}
					</div>
					<form id="casper_sms" onSubmit={(ev) => this.verifyClicked(ev)} method="post" className={styles.form}>
						<div className={styles.formGroup}>
							<label htmlFor="token">{_('codeLabel')}</label>
							<input id="casper_sms" ref="token" name="token" autoFocus/>
						</div>
						<div className={styles.errorMessage}>
							{errors && _(errors.id)}
						</div>
						<div className={styles.formGroup}>
							<button id="casper_sms" className={styles.submitButton}>{_('verification')}</button>
						</div>
					</form>
				</div>
				{
				!options.smsResent &&
				<div id="casper_smsForgot" className={styles.additionalOption}>
					<a onClick={() => this.resendToken()}>{_('sendCodeMSG')}</a>
				</div>
			}
			</div>
	)
	}
}



// WEBPACK FOOTER //
// ./components/auth/sms.jsx